import { NgModule } from "@angular/core";
import { CardLoaderComponent } from "./card_loader.component";
import { CommonModule } from "@angular/common";
import { CardComponent } from "src/app/shared/components/card/card.component";
import { InputSearchModule } from "../../elementi-strutturali/input-search/input-search.module";
import { PaginatorModule } from "../../elementi-strutturali/paginator/paginator.module";


@NgModule({
  imports: [CommonModule, CardComponent,  PaginatorModule, InputSearchModule],
  declarations: [CardLoaderComponent],
  exports: [CardLoaderComponent],

})
export class CardLoaderModule {
  static component = CardLoaderComponent
}